import { ReactNode } from "react";
import BottomSheet from "@/components/shared/mobile/BottomSheet.tsx";

type RepliesWrapperArgs = {
  children: ReactNode;
  showSheet: boolean;
  isAnimating: boolean;
  closeSheet: () => void;
};

export default function RepliesWrapper({
  children,
  showSheet,
  isAnimating,
  closeSheet,
}: RepliesWrapperArgs) {
  return window.isApp ? (
    <BottomSheet
      showSheet={showSheet}
      isAnimating={isAnimating}
      onClose={closeSheet}
    >
      <div className="flex flex-col min-h-32 h-full">
        <div className="sticky top-0 bg-white pb-2.5">
          <span className="flex justify-center text-lg font-semibold">
            {I18n.t("activitystreams.activity.replies.header")}
          </span>
        </div>
        {children}
      </div>
    </BottomSheet>
  ) : (
    children
  );
}
